<template>
  <div class="not-found">
    <div class="content">
      <div class="icon">404</div>
      <h1 class="title">页面不存在</h1>
      <p class="desc">抱歉，您访问的页面不存在或已被删除</p>
      <button class="btn-back" @click="goHome">返回首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.not-found {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  padding: 20px;
}

.content {
  text-align: center;
}

.icon {
  font-size: 120px;
  font-weight: bold;
  color: #e0e0e0;
  line-height: 1;
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  color: #333;
  margin: 0 0 10px;
}

.desc {
  font-size: 14px;
  color: #999;
  margin: 0 0 30px;
}

.btn-back {
  padding: 12px 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.3s;
  
  &:active {
    opacity: 0.8;
  }
}
</style>
